/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CaseMatchSpecimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    /**
     * what is the source for the specimen
     */
    type?: CaseMatchSpecimen.type | null;
    site?: string | null;
    procedure?: CaseMatchSpecimen.procedure | null;
    source?: string | null;
}

export namespace CaseMatchSpecimen {

    /**
     * what is the source for the specimen
     */
    export enum type {
        MUCOSA = 'MUCOSA',
        SKIN = 'SKIN',
        NAIL = 'NAIL',
        SOFT_TISSUE = 'SOFT TISSUE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }

    export enum procedure {
        C = 'c',
        E = 'e',
        PE = 'pe',
        IB = 'ib',
        NC = 'nc',
        NA = 'na',
        PB = 'pb',
        SB = 'sb',
        SBD = 'sbd',
        SCE = 'sce',
        SR = 'sr',
        SRD = 'srd',
        SNB = 'snb',
        GR = 'gr',
        SE = 'se',
        EBX = 'ebx',
        FB = 'fb',
        MOHS = 'mohs',
        DBLK = 'dblk',
        U = 'u',
        O = 'o',
    }


}
